import React, { FunctionComponent, MutableRefObject } from 'react';

import { TaskStatuses } from '@api/v4/tasks';
import { TaskStatusLabels } from '@api/v4/tasks/TaskEnums';
import { ListDropdown, ListOption, ListOptionValue } from '@components/library/dropdown/index';

interface WorkspaceTaskStatusDropdownProps {
  id: string
  onChange: (listOption: ListOption) => void;
  value: ListOption | ListOptionValue;
  className?: string;
  overflowParentRef?: MutableRefObject<HTMLElement>;
  showAllOptions?: boolean;
}

const statusOptions: ListOption[] = [
  {
    label: bfTranslate(TaskStatusLabels.NotStarted),
    value: TaskStatuses.NotStarted
  },
  {
    label: bfTranslate(TaskStatusLabels.InProgress),
    value: TaskStatuses.InProgress
  },
  {
    label: bfTranslate(TaskStatusLabels.Completed),
    value: TaskStatuses.Completed
  },
];

const statusAllOption: ListOption = {
  label: bfTranslate(TaskStatusLabels.All),
  value: TaskStatuses.All
};

export const WorkspaceTaskStatusDropdown: FunctionComponent<WorkspaceTaskStatusDropdownProps> = (props) => {
  const { className, id, onChange, overflowParentRef, showAllOptions, value } = props;

  return (
    <ListDropdown
      className={className}
      id={id}
      onChange={onChange}
      options={showAllOptions ? [statusAllOption, ...statusOptions] : statusOptions}
      overflowParentRef={overflowParentRef}
      value={value}
      virtualizeOptions={false}
    />
  );
};
